import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import * as Icon from 'react-feather';
import CustomLoader from '../common/Loader';
import Tooltip from '@material-ui/core/Tooltip';
import { logActivity, getAppConfig, updateAppConfig, deleteAppConfig } from '../../services/utilService';

class appConfigurations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            appConfig: [],
            origAppConfig: [],
            currentEditIdx: 0,
            oldConfig: {},
            loading: true,
            show: false,
            isEdit: false,
            newConfig: {
                Configuration_Name: '',
                Configuration_Description: '',
                Configuration_Value: ''
            }
        }
    }

    async componentDidMount() {
        try {
            await getAppConfig().then((resp) => {
                this.setState({ appConfig: JSON.parse(resp.data.response), origAppConfig: JSON.parse(resp.data.response) });
                this.setState({ currentEditIdx: this.state.appConfig.length - 1, loading: false });
            })
        }
        catch (e) {
            console.error('Component Load failed: ', e)
        }
    }

    enableEdit = (idx) => {
        this.setState({ newConfig: this.state.appConfig[idx], currentEditIdx: idx, isEdit: true, show: true })
    };

    handleShow = () => {
        let newConfig = {
            Configuration_ID: 0,
            Configuration_Name: '',
            Configuration_Description: '',
            Configuration_Value: ''
        },
            appConfig = this.state.appConfig;
        appConfig.push(newConfig);
        this.setState({
            newConfig,
            appConfig,
            isEdit: false,
            currentEditIdx: this.state.appConfig.length - 1,
            show: true
        });
    };

    handleClose = () => {
        //console.log('this..', this.state);
        let appConfig = this.state.appConfig;
        if (this.state.isEdit) {
            appConfig[this.state.currentEditIdx] = this.state.origAppConfig[this.state.currentEditIdx];

        }
        else {
            delete (appConfig[this.state.currentEditIdx]);
            appConfig = appConfig.filter((el) => el !== undefined);
        }
        this.setState({ appConfig, currentEditIdx: this.state.currentEditIdx - 1, show: false });
    };

    handleConfigChange = (key, value) => {
        let newConfig = this.state.newConfig;
        newConfig[key] = value
        this.setState({ newConfig })
    };

    handleRemove = async (idx) => {
        try {
            await deleteAppConfig(this.state.appConfig[idx]['Configuration_ID']).then((resp) => {
                if ((resp.data).includes('Error')) {
                    toaster('error', 'Config Delete Failed');
                    logActivity("/appConfigurations", "DELETE_FAIL");
                }
                else {
                    toaster('success', 'Config Delete Success');
                    logActivity("/appConfigurations", "DELETE_SUCCESS");
                    let appConfig = this.state.appConfig;
                    delete (appConfig[idx]);
                    appConfig = appConfig.filter((el) => el !== undefined);
                    this.setState({ appConfig });
                }
            })
        }
        catch (e) {
            console.error('Component Delete Error: ', e)
        }
    };

    handleSave = async () => {
        try {
            await updateAppConfig(this.state.appConfig[this.state.currentEditIdx]).then((resp) => {
                if ((resp.data).includes('Error')) {
                    toaster('error', 'Config Save/Update Failed');
                    logActivity("/appConfigurations", "UPDATE_SUCCESS");
                    this.setState({ show: false });
                }
                else {
                    toaster('success', 'Config Save/Update Success');
                    logActivity("/appConfigurations", "UPDATE_FAIL");
                    //console.log('resp', (resp.data).split(':')[1]);
                    let appConfig = this.state.appConfig;
                    appConfig[this.state.currentEditIdx]['Configuration_ID'] = parseInt((resp.data).split(':')[1]);
                    this.setState({ appConfig, origAppConfig: appConfig, show: false })
                }
            })
        }
        catch (e) {
            console.error('Component Save/Update Error: ', e)
        }
    };

    render() {
        let { appConfig, show, newConfig, loading } = this.state;
        if (loading) {
            return <CustomLoader loading={loading} />;
        }
        return (
            <React.Fragment>
                <header className='page-header page-header-dark bg-gradient-primary-to-secondary pb-10'>
                    <div className='container'>
                        <div className='page-header-content pt-4'>
                            <div className='row align-items-center justify-content-between'>
                                <div className='col-auto mt-4'>
                                    <h1 className='page-header-title'>
                                        <div className='page-header-icon'>
                                            <Icon.Settings />
                                        </div>
                                        Application Configurations
                                    </h1>
                                    <div className='page-header-subtitle'>
                                        MQUARK Config management application wide.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className='container mt-n10'>
                    <div className='card card-header-actions'>
                        <div className='card-body'>
                            <div className='float-right'>
                                <button className='btn btn-pink btn-icon mr-2' onClick={this.handleShow}>
                                    <Icon.PlusCircle />
                                </button>
                                <Modal show={show} onHide={this.handleClose}>
                                    <Modal.Header closeButton>Add/Edit Config</Modal.Header>
                                    <Modal.Body>
                                        <form>
                                            <div className='form-group'>
                                                <label htmlFor='FirstName'>Config Name</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='Configuration_Name'
                                                    name='Configuration_Name'
                                                    value={newConfig.Configuration_Name}
                                                    onChange={(e) => this.handleConfigChange('Configuration_Name', e.target.value)}
                                                />
                                            </div>

                                            <div className='form-group'>
                                                <label htmlFor='LastName'>Config Description</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='Configuration_Description'
                                                    name='Configuration_Description'
                                                    value={newConfig.Configuration_Description}
                                                    onChange={(e) => this.handleConfigChange('Configuration_Description', e.target.value)}
                                                />
                                            </div>
                                            <div>
                                                <label htmlFor='Configuration_Value'>Config Value</label>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    id='Configuration_Value'
                                                    name='Configuration_Value'
                                                    value={newConfig.Configuration_Value}
                                                    onChange={(e) => this.handleConfigChange('Configuration_Value', e.target.value)}
                                                />
                                            </div>
                                        </form>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button className='btn btn-primary' onClick={this.handleSave}>
                                            Save
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                            <table className='table table-hover table-borderless table-sm' style={{ tableLayout: 'fixed' }}>
                                <thead className='border-bottom'>
                                    <tr>
                                        <th>Config ID</th>
                                        <th>Config Name</th>
                                        <th>Config Description</th>
                                        <th>Config Value</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {appConfig.map((config, idx) => {
                                        return (
                                            <tr key={config.Configuration_Name}>
                                                <td>{config.Configuration_ID === 0 ? '' : config.Configuration_ID}</td>
                                                <td>{config.Configuration_Name}</td>
                                                <td>{config.Configuration_Description}</td>
                                                <td>{config.Configuration_Value}</td>
                                                <td>
                                                    <Tooltip title='Edit' id={`edit-${config.Configuration_ID}`}>
                                                        <span className='badge badge-cyan' onClick={() => this.enableEdit(idx)}>
                                                            <Icon.Edit size={20} />
                                                        </span>
                                                    </Tooltip>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <Tooltip title='Delete' id={`delete-${config.Configuration_ID}`}>
                                                        <span className='badge badge-danger' onClick={() => this.handleRemove(idx)}>
                                                            <Icon.Trash2 size={20} />
                                                        </span>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </React.Fragment>
        );
    }
}

export default appConfigurations;